var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.pageTitle } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "pb-5 mx-0" },
            [_c("back-button", { attrs: { returnUrl: _vm.returnUrl } })],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      disabled:
                        _vm.mode === "details" && _vm.editMode === false,
                      inputLabel: _vm.$t("common.routing.message"),
                      placeholderValue: _vm.$t("common.routing.message"),
                    },
                    model: {
                      value: _vm.message,
                      callback: function ($$v) {
                        _vm.message = $$v
                      },
                      expression: "message",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-col",
                { staticClass: "form-group", attrs: { sm: "6" } },
                [
                  _c("form-write-group-label-input", {
                    attrs: {
                      isMandatory: "",
                      disabled:
                        _vm.mode === "details" && _vm.editMode === false,
                      inputLabel: _vm.$t("common.routing.receiver_id"),
                      placeholderValue: _vm.$t("common.routing.receiver_id"),
                    },
                    model: {
                      value: _vm.receiverId,
                      callback: function ($$v) {
                        _vm.receiverId = $$v
                      },
                      expression: "receiverId",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("common.routing.format_name"))
                  ),
                  _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.idFormat,
                        expression: "idFormat",
                      },
                    ],
                    staticClass: "form-control",
                    class: _vm.selectFormatColor,
                    attrs: {
                      readonly: "",
                      disabled:
                        _vm.mode === "details" && _vm.editMode === false,
                    },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.idFormat = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c(
                      "option",
                      { attrs: { value: "null", disabled: "", hidden: "" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("common.routing.select_format")) +
                            " "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.formatList, function (item, index) {
                      return _c(
                        "option",
                        {
                          key: index,
                          staticClass: "color-black-message-details",
                          domProps: { value: item.IdFormat },
                        },
                        [_vm._v(_vm._s(item.Name))]
                      )
                    }),
                  ],
                  2
                ),
              ]),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", [
                  _vm._v(
                    "\n          " +
                      _vm._s(_vm.$t("common.routing.config_type"))
                  ),
                  _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.configType,
                        expression: "configType",
                      },
                    ],
                    staticClass: "form-control",
                    class: _vm.selectTypeColor,
                    attrs: {
                      readonly: "",
                      disabled:
                        _vm.mode === "details" && _vm.editMode === false,
                    },
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.configType = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        _vm.onChangeConfigType,
                      ],
                    },
                  },
                  [
                    _c(
                      "option",
                      { attrs: { value: "null", hidden: "", disabled: "" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("common.routing.select_config_type")
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "option",
                      {
                        staticClass: "color-black-message-details",
                        attrs: { value: "INTERPROCESS" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("common.routing.inter_process")) +
                            " "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "option",
                      {
                        staticClass: "color-black-message-details",
                        attrs: { value: "MQSERIES" },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("common.routing.mqseries")) + " "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "option",
                      {
                        staticClass: "color-black-message-details",
                        attrs: { value: "REMOTEFOLDER" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("common.routing.remote_folder")) +
                            " "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "option",
                      {
                        staticClass: "color-black-message-details",
                        attrs: { value: "WEBSERVICE" },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("common.routing.web_service")) +
                            " "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "option",
                      {
                        staticClass: "color-black-message-details",
                        attrs: { value: "KAFKA" },
                      },
                      [
                        _vm._v(
                          " " + _vm._s(_vm.$t("common.routing.kafka")) + " "
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _vm.isInterProcess
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("label", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("common.routing.config_name"))
                        ),
                        _c("span", { staticClass: "color-red" }, [
                          _vm._v(" * "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.configInterProcessId,
                              expression: "configInterProcessId",
                            },
                          ],
                          staticClass: "form-control",
                          class: _vm.selectInterProcessColor,
                          attrs: {
                            readonly: "",
                            disabled:
                              _vm.mode === "details" && _vm.editMode === false,
                          },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.configInterProcessId = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: {
                                value: "null",
                                disabled: "",
                                hidden: "",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("common.routing.select_config")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.interProcessList, function (item, index) {
                            return _c(
                              "option",
                              {
                                key: index,
                                staticClass: "color-black-message-details",
                                domProps: { value: item.IdInterProcess },
                              },
                              [_vm._v(_vm._s(item.Name))]
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isMQSeries
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("label", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("common.routing.config_name"))
                        ),
                        _c("span", { staticClass: "color-red" }, [
                          _vm._v(" * "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.configMQSeriesId,
                              expression: "configMQSeriesId",
                            },
                          ],
                          staticClass: "form-control",
                          class: _vm.selectMQSeriesColor,
                          attrs: {
                            readonly: "",
                            disabled:
                              _vm.mode === "details" && _vm.editMode === false,
                          },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.configMQSeriesId = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: {
                                value: "null",
                                disabled: "",
                                hidden: "",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("common.routing.select_config")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.mqseriesList, function (item, index) {
                            return _c(
                              "option",
                              {
                                key: index,
                                staticClass: "color-black-message-details",
                                domProps: { value: item.IdMQSeries },
                              },
                              [_vm._v(_vm._s(item.Name))]
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isRemoteFolder
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("label", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("common.routing.config_name"))
                        ),
                        _c("span", { staticClass: "color-red" }, [
                          _vm._v(" * "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.configRemoteFolderId,
                              expression: "configRemoteFolderId",
                            },
                          ],
                          staticClass: "form-control",
                          class: _vm.selectRemoteFolderColor,
                          attrs: {
                            readonly: "",
                            disabled:
                              _vm.mode === "details" && _vm.editMode === false,
                          },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.configRemoteFolderId = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: {
                                value: "null",
                                disabled: "",
                                hidden: "",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("common.routing.select_config")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.remoteFolderList, function (item, index) {
                            return _c(
                              "option",
                              {
                                key: index,
                                staticClass: "color-black-message-details",
                                domProps: { value: item.IdRemoteFolder },
                              },
                              [_vm._v(_vm._s(item.Name))]
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isWebService
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("label", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("common.routing.config_name"))
                        ),
                        _c("span", { staticClass: "color-red" }, [
                          _vm._v(" * "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.configWebServiceId,
                              expression: "configWebServiceId",
                            },
                          ],
                          staticClass: "form-control",
                          class: _vm.selectWebServiceColor,
                          attrs: {
                            readonly: "",
                            disabled:
                              _vm.mode === "details" && _vm.editMode === false,
                          },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.configWebServiceId = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: {
                                value: "null",
                                disabled: "",
                                hidden: "",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("common.routing.select_config")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.webServiceList, function (item, index) {
                            return _c(
                              "option",
                              {
                                key: index,
                                staticClass: "color-black-message-details",
                                domProps: { value: item.IdWebService },
                              },
                              [_vm._v(_vm._s(item.Name))]
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.isKafka
                ? _c(
                    "b-col",
                    { staticClass: "form-group", attrs: { sm: "6" } },
                    [
                      _c("label", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.$t("common.routing.config_name"))
                        ),
                        _c("span", { staticClass: "color-red" }, [
                          _vm._v(" * "),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.configKafkaId,
                              expression: "configKafkaId",
                            },
                          ],
                          staticClass: "form-control",
                          class: _vm.selectWebServiceColor,
                          attrs: {
                            readonly: "",
                            disabled:
                              _vm.mode === "details" && _vm.editMode === false,
                          },
                          on: {
                            change: function ($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function (o) {
                                  return o.selected
                                })
                                .map(function (o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.configKafkaId = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            },
                          },
                        },
                        [
                          _c(
                            "option",
                            {
                              attrs: {
                                value: "null",
                                disabled: "",
                                hidden: "",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("common.routing.select_config")
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.kafkaList, function (item, index) {
                            return _c(
                              "option",
                              {
                                key: index,
                                staticClass: "color-black-message-details",
                                domProps: { value: item.idConfigKafka },
                              },
                              [_vm._v(_vm._s(item.name))]
                            )
                          }),
                        ],
                        2
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("b-col", { staticClass: "form-group", attrs: { sm: "6" } }, [
                _c("label", [
                  _vm._v(
                    "\n          " + _vm._s(_vm.$t("common.routing.standard"))
                  ),
                  _c("span", { staticClass: "color-red" }, [_vm._v(" * ")]),
                ]),
                _vm._v(" "),
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.idStandard,
                        expression: "idStandard",
                      },
                    ],
                    staticClass: "form-control",
                    class: _vm.selectFormatColor,
                    attrs: {
                      readonly: "",
                      disabled:
                        _vm.mode === "details" && _vm.editMode === false,
                    },
                    on: {
                      change: function ($event) {
                        var $$selectedVal = Array.prototype.filter
                          .call($event.target.options, function (o) {
                            return o.selected
                          })
                          .map(function (o) {
                            var val = "_value" in o ? o._value : o.value
                            return val
                          })
                        _vm.idStandard = $event.target.multiple
                          ? $$selectedVal
                          : $$selectedVal[0]
                      },
                    },
                  },
                  [
                    _c(
                      "option",
                      { attrs: { value: "null", disabled: "", hidden: "" } },
                      [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("common.routing.select_standard")) +
                            " "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _vm._l(_vm.standardList, function (item, index) {
                      return _c(
                        "option",
                        {
                          key: index,
                          staticClass: "color-black-message-details",
                          domProps: { value: item.IdStandard },
                        },
                        [_vm._v(_vm._s(item.Name))]
                      )
                    }),
                  ],
                  2
                ),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "justify-content-end mt-3 no-gutters" },
            [
              _vm.mode === "create"
                ? _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.createMessageRouting },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-save" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.mode === "details" &&
              _vm.editMode === false &&
              _vm.canEditMessage
                ? _c(
                    "b-button",
                    {
                      staticClass: "mr-3",
                      attrs: { variant: "primary" },
                      on: { click: _vm.editModeActivate },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(_vm.$t("common.routing.edit_this_message"))
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.mode === "details" &&
              _vm.editMode === false &&
              _vm.canDeleteMessage
                ? _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.deleteMessageRouting },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-trash" }),
                      _vm._v(" "),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("common.routing.delete_message"))),
                      ]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.mode === "details" && _vm.editMode === true
                ? _c(
                    "b-button",
                    {
                      attrs: { variant: "primary" },
                      on: { click: _vm.editMessageRouting },
                    },
                    [
                      _c("i", { staticClass: "fa-light fa-save" }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.sve")))]),
                    ]
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }